import { render, staticRenderFns } from "./TextTyper.vue?vue&type=template&id=b835b36c"
import script from "./TextTyper.vue?vue&type=script&lang=js"
export * from "./TextTyper.vue?vue&type=script&lang=js"
import style0 from "./TextTyper.vue?vue&type=style&index=0&id=b835b36c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports